import React from 'react';
import ReactDOM from 'react-dom';
import './SplitBar.css';

class SplitBar extends React.Component {
  state = {
    open: false
  };

  minWidth = 560;
  barWidth = 2;

  componentDidMount = () => {
    window.addEventListener('resize', () => {
      if (this.rightDom && this.state.open) {
        let leftWidth = parseInt(this.props.left.style.width, 10);
        if (leftWidth > window.innerWidth - this.barWidth || window.innerWidth - this.barWidth - leftWidth < this.minWidth) {
          this.props.left.style.width = (window.innerWidth - this.barWidth) + 'px';
          this.setState({open:false});
        }
        this.rightDom.style.width = (window.innerWidth - parseInt(this.props.left.style.width, 10) - this.barWidth) + 'px';
      }
      else {
        this.props.left.style.width = (window.innerWidth - this.barWidth) + 'px';
      }
    });
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.currentSelect && this.props.currentSelect !== prevProps.currentSelect) { // open
      this.rightDom = ReactDOM.findDOMNode(this.props.right)
      let rightWidth = 0;
      let leftWidth = 0;
      if (!prevState.open) {
        if (window.innerWidth < this.minWidth * 2 + this.barWidth) {
          rightWidth = window.innerWidth - this.barWidth;
        }
        else {
          rightWidth = Math.floor(window.innerWidth / 2) - this.barWidth;
          if (window.innerWidth - this.barWidth - rightWidth < this.minWidth) rightWidth = window.innerWidth;
          leftWidth = window.innerWidth - rightWidth - this.barWidth;
        }
      }
      else {
        rightWidth = this.rightDom.getBoundingClientRect().width;
        if (rightWidth === 0) {
          rightWidth = Math.floor(window.innerWidth / 2) - this.barWidth;
        }
        leftWidth = window.innerWidth - rightWidth - this.barWidth;
      }
      this.rightDom.style.width   = rightWidth + 'px';
      this.props.left.style.width = leftWidth  + 'px';
      this.setState({open:true});
    }
    if (prevState.open && !this.state.open && this.props.onClose) {
      this.props.onClose();
    }
  }


  handleMouseDown = (e) => {
    document.body.addEventListener('mousemove', this.handleMouseMove, false);
    document.body.addEventListener('mouseup', this.handleMouseUp, false);
    e.stopPropagation();
    e.preventDefault();
  }
  handleMouseMove = (e) => {
    let leftWidth = e.clientX;
    if (leftWidth < this.minWidth) leftWidth = this.minWidth;
    let rightWidth = window.innerWidth - leftWidth - this.barWidth;
    if (rightWidth < this.minWidth-this.barWidth) {
      rightWidth = 0;
      leftWidth = window.innerWidth - this.barWidth;
    }
    
    this.props.left.style.width = leftWidth + 'px';
    this.rightDom.style.width = rightWidth + 'px';
    e.stopPropagation();
    e.preventDefault();
  }
  handleMouseUp = (e) => {
    document.body.removeEventListener('mousemove', this.handleMouseMove, false);
    document.body.removeEventListener('mouseup', this.handleMouseUp, false);
    e.stopPropagation();
    e.preventDefault();

    if (!this.rightDom) this.rightDom = ReactDOM.findDOMNode(this.props.right);
    if (this.rightDom.getBoundingClientRect().width === 0) {
      this.setState({open:false});
    }
  }

  close = () => {
    this.props.left.style.width = (window.innerWidth - this.barWidth) + 'px';
    this.setState({open:false});
  }

  render() {
    return (
      <div className="SplitBar" onMouseDown={this.handleMouseDown}></div>
    );
  }
}
SplitBar.setPosition = (pos) => {
  
}
export default SplitBar;